
import { motion } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useAccessCode } from "@/contexts/AccessCodeContext";

const AccessCodeSection = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const { toast } = useToast();
  const { authenticate, isAuthenticated } = useAccessCode();

  const handleCodeSubmit = () => {
    if (authenticate(code)) {
      toast({
        title: "Access Granted!",
        description: "You now have access to all doozy tools.",
      });
      navigate("/services");
    } else {
      toast({
        title: "Invalid Code",
        description: "Please enter a valid access code or explore our pricing plans.",
        variant: "destructive",
      });
    }
  };

  if (isAuthenticated) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2 }}
        className="max-w-md mx-auto mb-20"
      >
        <Card className="border-green-200 bg-green-50/50">
          <CardContent className="p-8 text-center">
            <h3 className="text-2xl font-bold mb-4 text-green-800">Access Granted!</h3>
            <p className="text-green-700 mb-6">
              You have full access to all doozy tools
            </p>
            <Button
              onClick={() => navigate("/services")}
              className="w-full bg-green-600 hover:bg-green-700"
            >
              Access Tools
            </Button>
          </CardContent>
        </Card>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2 }}
      className="max-w-md mx-auto mb-20"
    >
      <Card className="border-border bg-card/50 backdrop-blur-sm">
        <CardContent className="p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Have an Access Code?</h3>
          <p className="text-muted-foreground mb-6">
            Enter your code to unlock premium tools instantly
          </p>
          
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Enter access code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleCodeSubmit()}
              className="w-full px-4 py-3 bg-background/50 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-center"
            />
            <Button
              onClick={handleCodeSubmit}
              className="w-full"
            >
              Unlock Tools
            </Button>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default AccessCodeSection;
